import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import styled from 'styled-components'

import Radio from '@material-ui/core/Radio'
import Typography from '@material-ui/core/Typography'
import DashboardIcon from 'components/atoms/DashboardIcon'

const styles = theme => ({
  root: {
    height: 64,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  text: {
    fontSize: 16,
  },
  embeddedText: {
    fontSize: 16,
    marginLeft: '10px',
  },
  underline: {
    borderBottom: `1px solid ${theme.palette.background.light}`,
  },
})

const StyledImg = styled.img`
  width: 40px;
  height: 40px; 
`

const Container = styled.div`
  display: flex; 
  align-items: center;
`

const CheckboxInput = ({
  active,
  classes,
  className,
  text,
  value,
  onClick,
  underline,
  image,
  isPopover
}) => {
  function handleClick() {
    onClick(value)
  }

  return (
    <div
      className={classNames(
        classes.root,
        underline && classes.underline,
        className
      )}>
      {isPopover ? 
        <Container >
          {image ? 
            <StyledImg alt={`logo for ${text}`} src={image} /> : 
            <DashboardIcon />
          }
          <Typography className={classes.embeddedText}>{text}</Typography>
        </Container> : 
        <Typography className={classes.text}>{text}</Typography>
      }
      <Radio color="primary" checked={active} onClick={handleClick} />
    </div>
  )
}

CheckboxInput.defaultProps = {
  underline: true,
}

CheckboxInput.propTypes = {
  text: PropTypes.string,
  active: PropTypes.bool,
  value: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.object,
  underline: PropTypes.bool,
  className: PropTypes.string,
  image: PropTypes.string, 
  isPopover: PropTypes.bool,
}

export default withStyles(styles)(CheckboxInput)



// WEBPACK FOOTER //
// ./src/components/molecules/CheckboxInput.js